import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('droneActivityLink');

    return {
        VIEW_RECENT_ACTIVITY: t('viewRecentActivity')
    };
};

export default useTranslation;
